import WidgetModule from "@eisinc/Overrides/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";

export * from "@eisinc/Overrides/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";

export default WidgetModule;
